import React, { useEffect }  from "react";
import LeaveTable from "./components/LeaveTable";
import { connect } from "react-redux";

const Leaves = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<LeaveTable />
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Leaves);